import ReportService from '../services/ReportService'

// Descarga del report en PDF (format=pdf) con los mismos filtros activos que el Excel.
// Requiere el mixin errorHandler y `this.params` en el componente.
export default {
  data: () => ({
    loadingPdf: false
  }),

  methods: {
    async downloadPdf (reportNumber) {
      this.loadingPdf = true
      try {
        const response = await ReportService.downloadReportPdf(reportNumber, this.params)
        const blob = response.data

        if (!blob || blob.size === 0) {
          throw new Error('El archivo descargado está vacío')
        }

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.pdfFilename(response, reportNumber)
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$toast.success('PDF descargado correctamente')
      } catch (error) {
        // Con responseType blob, los errores JSON (401/403) llegan como Blob: se leen antes de tratarlos
        const data = error.response && error.response.data
        if (data instanceof Blob) {
          try {
            error.response.data = JSON.parse(await data.text())
          } catch (e) { /* no era JSON */ }
        }
        this.handleApiError(error, 'Error al descargar el PDF del reporte')
      } finally {
        this.loadingPdf = false
      }
    },

    // Nombre del Content-Disposition si el navegador lo expone; si no, el mismo formato por defecto
    pdfFilename (response, reportNumber) {
      const disposition = response.headers && response.headers['content-disposition']
      const match = disposition && /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
      if (match) return decodeURIComponent(match[1])
      return `PivotFleet_Report${reportNumber}_${new Date().toISOString().slice(0, 10)}.pdf`
    }
  }
}
